import { render, staticRenderFns } from "./GenericIndexPage.vue?vue&type=template&id=231c637e&scoped=true&"
import script from "./GenericIndexPage.vue?vue&type=script&lang=js&"
export * from "./GenericIndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c637e",
  null
  
)

export default component.exports